import { Component, HostBinding, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolTabState } from './sol-tab.state';

@Component({
  selector: 'sol-tab',
  imports: [],
  templateUrl: './sol-tab.component.html',
})
export class SolTabComponent extends AbstractComponent<SolTabState> {
  // Computed
  protected readonly id$ = this.compute(state => state.id);
  protected readonly visible$ = this.compute(state => state.visible);

  constructor() {
    super(SolTabState.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return this.visible$() ? 'sol-tab' : '';
  }

  @Input()
  public set id(id: string) {
    this.update(state => state.withId(id));
  }

  public get id() {
    return this.id$();
  }

  @Input()
  public set visible(visible: boolean) {
    this.update(state => state.withVisible(visible));
  }
}
